import React from "react";
import {
  CreateGridData,
  RenderMasterGrid,
} from "../../../helper/Grid/GridCreatorMixin";
import { useTranslation } from "react-i18next";

const LogReportGrid = () => {
  const { t } = useTranslation();
  const pageGrid = {
    apiController: "LogView",
    apiKey: "Id",
    editTitle: t("logInfo"),
    selection: false,
    editMode: {
      isActive: false,
      mode: "form",
      allowAdding: false,
      allowDeleting: false,
      allowUpdating: false,
      allowCopy: false,
      useIcons: false,
      containerColCount: 1,
      validationSummary: true,
    },
    columns: [
      {
        dataField: "LogLevel",
        caption: t("logLevel"),
      },
      {
        dataField: "CategoryName",
        caption: t("category"),
      },
      {
        dataField: "Message",
        caption: t("message"),
      },
      {
        dataField: "CreateDate",
        caption: t("logDate"),
        dataType: "date",
        format: "dd/MM/yyyy HH:mm",
        sortOrder: "desc",
      },
    ],
  };

  let gridData = CreateGridData(pageGrid);

  return <RenderMasterGrid gridData={gridData} />;
};
export default LogReportGrid;
